/**
 * Portal route templates (AIC-336). The analyst portal's client routes (apps/analyst-portal/src/App.tsx screenFor, plus
 * the sign-in pages): the only route list the browser bundle may import
 * (`@swtracker/core/telemetry/portal-routes`). Telemetry carries a template, never a raw path, id or query string.
 *
 * Claude-owned; the portal imports it read-only. Browser-safe: no imports at all, and it must never import (or
 * re-export) the server route lists in routes.ts, which name /internal/* and /api/* routes. The test in
 * telemetry.test.ts imports this module alone and checks it carries no API or /internal route.
 */

/** The analyst portal's client-side route templates. A route_ready or web-vitals sample must name one of these. */
export const PORTAL_ROUTE_TEMPLATES = Object.freeze([
  "/",
  "/today",
  "/assignments",
  "/assignments/:id",
  "/assignments/:id/preview",
  "/review",
  "/results/:id",
  "/dashboard",
  "/help",
  "/profile",
  "/profile/:id",
  "/practice",
  "/practice/outbox",
  "/insights",
  "/insights/:tab",
  "/admin/people",
  "/admin/analyst-preview",
  "/admin/cycle",
  "/admin/cycle/imports",
  "/admin/cycle/reconciliation",
  "/admin/settings",
  "/auth/login",
  "/auth/callback",
] as const);
export type PortalRouteTemplate = (typeof PORTAL_ROUTE_TEMPLATES)[number];

const PORTAL_SET: ReadonlySet<string> = new Set(PORTAL_ROUTE_TEMPLATES);
export const isPortalRouteTemplate = (s: unknown): s is PortalRouteTemplate => typeof s === "string" && PORTAL_SET.has(s);
